<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import colors from "../assets/colors"
  import { getColor, downloadDataAndSettings, uploadDataAndSettings, testJSON } from "../utility.js"
  import { commandsData } from "../assets/data"

  export let isLoading, settings
  const fonts = ["system-ui", "Consolas Regular", "Consolas Bold", "Courier Prime Regular", "Courier Prime Bold"]

  const download = () => downloadDataAndSettings({ newCommands: $commandsData, newSettings: settings, newColors: colors })
  const upload = async () => {
    const data = await uploadDataAndSettings()
    try {
      const { newCommands, newSettings, newColors } = testJSON(data)
      dispatch("uploaded", { newCommands, newSettings, newColors })
    } catch (error) {
      alert(error)
    }
  }
</script>

<div class="flex flex-col gap-4">
  <div class="flex">
    <label for="fontSize" class="settings-text">Font Size (px)</label>
    <input id="fontSize" bind:value={settings.fontSize.value} type="number" class="settings" disabled={isLoading} />
  </div>
  <div class="flex">
    <label for="fontFamily" class="settings-text">Font</label>
    <select id="fontFamily" bind:value={settings.fontFamily.value} disabled={isLoading} class="settings !w-1/2">
      {#each fonts as font}
        <option value={font}>{font}</option>
      {/each}
    </select>
  </div>
  <div class="flex">
    <label for="width" class="settings-text">Width</label>
    <input id="width" bind:value={settings.width.value} type="number" class="settings" disabled={isLoading} step="10" />
  </div>
  <div class="flex">
    <label for="height" class="settings-text">Height</label>
    <input id="height" bind:value={settings.height.value} type="number" class="settings" disabled={isLoading} step="10" />
  </div>
  <div class="flex">
    <label for="typeWaitMs" class="settings-text">Text Speed</label>
    <input id="typeWaitMs" bind:value={settings.typeWaitMs.value} type="number" class="settings" disabled={isLoading} step="10" />
  </div>
  {#each Object.keys(colors) as colorKey}
    <div class="flex">
      <label for={colorKey} class="settings-text">{colors[colorKey].text}</label>
      <input id={colorKey} bind:value={colors[colorKey].color} type="text" class="settings" disabled={isLoading} />
      <label for={`${colorKey}-picker`} class="color-preview border relative" style:background-color={getColor(colors[colorKey])}>
        <input id={`${colorKey}-picker`} class="invisible" type="color" bind:value={colors[colorKey].color} />
      </label>
    </div>
  {/each}

  <div class="flex justify-between">
    <button type="button" class="app-btn bg-lime-600" on:click={download}>Download JSON</button>
    <button type="button" class="app-btn bg-lime-600" on:click={upload}>Upload JSON</button>
  </div>
</div>

<style lang="postcss" scoped>
  .settings-text {
    @apply mr-auto outline-none font-medium text-gray-900 dark:text-gray-400;
  }

  .settings {
    @apply border-none bg-gray-100 py-1 px-2 rounded-md w-2/6 text-sm font-medium outline-none;
  }

  .color-preview {
    @apply w-4 h-4 ml-4 rounded-3xl self-center;
  }

  .border {
    border: 1px solid gray;
  }
</style>
